import { styled } from '@mui/material';

import { ReactComponent as AddIcon } from 'assets/icons/containerActions/addSquare.svg';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 56px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;

export const EmptyStateW = styled('div')`
  position: relative;
  flex-direction: column;
  flex: 1;
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  backdrop-filter: blur(20px);
  display: flex;
  align-items: flex-end;
  @media (max-width: 1023px) {
    min-height: 258px;
    padding: 16px;
  }
`;

export const ContentW = styled('div')`
  margin-top: 8px;
  width: 100%;

  @media (max-width: 1023px) {
    margin-top: 16px;
  }
`;

export const Header = styled('div')`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  width: 100%;
`;

export const StyledAddIcon = styled(AddIcon)`
  opacity: 0.4;
`;
